import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/sensor.state';
import sensorType from '../types/sensor.type';
import ISensorState from '../models/ISensorState';

const getAllSensorStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensorList: updateObject(oldState.sensorList, {
            error: null, loading: true
        })
    });
};

const getAllSensorSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensorList: updateObject(oldState.sensorList, {
            sensors: action.payload,
            error: null,
            loading: false
        })
    });
};

const resetAllSensorState = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensorList: updateObject(oldState.sensorList, {
            sensors: action.payload,
            error: null,
            loading: true
        })
    });
};

const getAllSensorError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensorList: updateObject(oldState.sensorList, {
            error: action.payload,
            loading: false
        })
    });
};

const deleteSensorStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        deleteSensor: updateObject(oldState.deleteSensor, {
            loading: true
        })
    });
};

const deleteSensorSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        deleteSensor: updateObject(oldState.deleteSensor, {
            success: true,
            error: null,
            loading: false
        })
    });
};

const deleteSensorError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        deleteSensor: updateObject(oldState.deleteSensor, {
            success: false,
            error: action.payload,
            loading: false
        })
    });
};

const resetDeleteSensorState = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        deleteSensor: initialState.deleteSensor
    });
};

const addSensorStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        addSensor: updateObject(oldState.addSensor, {
            loading: true,
            success: false,
            error: null
        })
    });
};

const addSensorSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        addSensor: updateObject(oldState.addSensor, {
            success: true,
            error: null,
            loading: false
        })
    });
};

const addSensorError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        addSensor: updateObject(oldState.addSensor, {
            success: false,
            error: action.payload,
            loading: false
        })
    });
};

const resetAddSensorState = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        addSensor: initialState.addSensor
    });
};

const getSensorFilterStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensor: updateObject(oldState.sensor, {
            loading: true
        })
    });
};

const getSensorFilterSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensor: updateObject(oldState.sensor, {
            sensor: action.payload,
            error: null,
            loading: false
        })
    });

    /* return updateObject(oldState, {
        sensor:action.payload
    }); */
};

const getSensorFilterError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensor: updateObject(oldState.sensor, {
            sensor: null,
            error: 'Some Error Occured',
            loading: false
        })
    });
};

const getSensorByIdStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensor: updateObject(oldState.sensor, {
            loading: true
        })
    });
};

const getSensorByIdSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensor: updateObject(oldState.sensor, {
            sensor: action.payload,
            error: null,
            loading: false
        })
    });
};

const getUniqueBuildingError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        buildingList: updateObject(oldState.buildingList, {
            buildings: null,
            error: 'Some Error Occured',
            loading: false
        })
    });
};

const getUniqueBuildingStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        buildingList: updateObject(oldState.buildingList, {
            loading: true
        })
    });
};

const getUniqueBuildingSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        buildingList: updateObject(oldState.buildingList, {
            buildings: action.payload,
            error: null,
            loading: false
        })
    });
};

const getSensorByIdError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensor: updateObject(oldState.sensor, {
            sensor: null,
            error: 'Some Error Occured',
            loading: false
        })
    });
};

const resetGetSensorByIdState = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        sensor: initialState.sensor
    });
};

const getAllDevicesStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        allDevices: updateObject(oldState.allDevices, {
            error: null, loading: true
        })
    });
};

const getAllDevicesSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        allDevices: updateObject(oldState.allDevices, {
            devices: action.payload,
            error: null,
            loading: false
        })
    });
};

const resetAllDevicesState = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        allDevices: updateObject(oldState.allDevices, {
            devices: action.payload,
            error: null,
            loading: true
        })
    });
};

const getAllDevicesError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        allDevices: updateObject(oldState.allDevices, {
            error: action.payload,
            loading: false
        })
    });
};

const updateDeviceAccessStart = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        updateDeviceAccess: updateObject(oldState.updateDeviceAccess, {
            loading: true,
            success: false,
            error: null
        })
    });
};

const updateDeviceAccessSuccess = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        updateDeviceAccess: updateObject(oldState.updateDeviceAccess, {
            success: true,
            error: null,
            loading: false
        })
    });
};

const updateDeviceAccessError = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        updateDeviceAccess: updateObject(oldState.updateDeviceAccess, {
            success: false,
            error: action.payload,
            loading: false
        })
    });
};

const resetUpdateDeviceAccessState = (oldState: ISensorState, action: any) => {
    return updateObject(oldState, {
        updateDeviceAccess: initialState.updateDeviceAccess
    });
};

const sensorReducer = (oldState: ISensorState = initialState, action: any) => {
    switch (action.type) {
        case sensorType.GET_ALL_SENSOR_START: return getAllSensorStart(oldState, action);
        case sensorType.GET_ALL_SENSOR_SUCCESS: return getAllSensorSuccess(oldState, action);
        case sensorType.RESET_ALL_SENSOR_STATE: return resetAllSensorState(oldState, action);
        case sensorType.GET_ALL_SENSOR_ERROR: return getAllSensorError(oldState, action);
        case sensorType.DELETE_SENSOR_START: return deleteSensorStart(oldState, action);
        case sensorType.DELETE_SENSOR_SUCCESS: return deleteSensorSuccess(oldState, action);
        case sensorType.DELETE_SENSOR_ERROR: return deleteSensorError(oldState, action);
        case sensorType.RESET_DELETE_SENSOR_STATE: return resetDeleteSensorState(oldState, action);
        case sensorType.ADD_SENSOR_START: return addSensorStart(oldState, action);
        case sensorType.ADD_SENSOR_SUCCESS: return addSensorSuccess(oldState, action);
        case sensorType.ADD_SENSOR_ERROR: return addSensorError(oldState, action);
        case sensorType.RESET_ADD_SENSOR_STATE: return resetAddSensorState(oldState, action);
        case sensorType.GET_SENSOR_BY_ID_START: return getSensorByIdStart(oldState, action);
        case sensorType.GET_SENSOR_BY_ID_SUCCESS: return getSensorByIdSuccess(oldState, action);
        case sensorType.GET_SENSOR_BY_ID_ERROR: return getSensorByIdError(oldState, action);
        case sensorType.GET_SENSOR_FILTER_START: return getSensorFilterStart(oldState, action);
        case sensorType.GET_SENSOR_FILTER_SUCCESS: return getSensorFilterSuccess(oldState, action);
        case sensorType.GET_SENSOR_FILTER_ERROR: return getSensorFilterError(oldState, action);
        case sensorType.RESET_GET_SENSOR_BY_ID_STATE: return resetGetSensorByIdState(oldState, action);

        case sensorType.GET_UNIQUE_BUILDING_START: return getUniqueBuildingStart(oldState, action);
        case sensorType.GET_UNIQUE_BUILDING_SUCCESS: return getUniqueBuildingSuccess(oldState, action);
        case sensorType.GET_UNIQUE_BUILDING_ERROR: return getUniqueBuildingError(oldState, action);

        case sensorType.GET_ALL_DEVICES_START: return getAllDevicesStart(oldState,action)
        case sensorType.GET_ALL_DEVICES_SUCCESS: return getAllDevicesSuccess(oldState,action)
        case sensorType.GET_ALL_DEVICES_ERROR: return getAllDevicesError(oldState,action)
        case sensorType.RESET_ALL_DEVICES_STATE: return resetAllDevicesState(oldState,action)

        case sensorType.UPDATE_DEVICE_ACCESS_START: return updateDeviceAccessStart(oldState, action);
        case sensorType.UPDATE_DEVICE_ACCESS_SUCCESS: return updateDeviceAccessSuccess(oldState, action);
        case sensorType.UPDATE_DEVICE_ACCESS_ERROR: return updateDeviceAccessError(oldState, action);
        case sensorType.RESET_UPDATE_DEVICE_ACCESS_STATE: return resetUpdateDeviceAccessState(oldState, action);

        default: return oldState;
    }
};
export default sensorReducer;